import {withNamespaces} from "react-i18next";
import CreditCardFormComponent from "../CreditCardForm/CreditCardForm.component";
import React from "react";
import PropTypes from "prop-types";
import PaymentCardSelectionComponent from "../PaymentCardSelection/PaymentCardSelection.component";
import PaymentMethod from "../../models/PaymentMethod";

const PaymentFormComponent = (props) => {

  const onPaymentMethodChange = (useDefault) => {
    props.onChange(new PaymentMethod({...props.paymentForm, use_default: useDefault}));
  }
  const onCardFieldChange = (field, value) => {
    const paymentMethod = new PaymentMethod({
      ...props.paymentForm,
      credit_card: {...props.paymentForm.credit_card, [field]: value}
    });
    props.onChange(paymentMethod);
  }

  return (
    <div>
      <PaymentCardSelectionComponent
        use_default={props.paymentForm.use_default}
        allowChangeCard={props.allowChangeCard}
        onChange={onPaymentMethodChange}
        default_card={props.default_card}/>

      <div className={`payment-form expandable${props.paymentForm.use_default ? ' not-shown' : ''}`}>
        <CreditCardFormComponent
          card={props.paymentForm.credit_card}
          errors={{}}
          onChange={onCardFieldChange}
        />
      </div>
    </div>
  );
};

PaymentFormComponent.propTypes = {
  paymentForm: PropTypes.object,
  default_card: PropTypes.object,
  onChange: PropTypes.func,
  allowChangeCard: PropTypes.bool,
};

export default withNamespaces()(PaymentFormComponent);